module.exports = __webpack_public_path__ + "static/media/search.db2c1b8e.svg";